import { useGetTenancy } from './useGetTenancy';

export const TenantHooks = {
    useGetTenancy
};
